// Shared admin theme contract. Keep this file identical in CRM, Workflow, Accounts and CMS.
export const appThemeNames = ['workbench', 'midnight'] as const
export type AppTheme = (typeof appThemeNames)[number]
export const themeLabels: Record<AppTheme, string> = { workbench: 'Workbench', midnight: 'Midnight' }

export function resolveTheme(saved: string | null | undefined): AppTheme {
  if (saved === 'dark') return 'midnight'
  return appThemeNames.includes(saved as AppTheme) ? saved as AppTheme : 'workbench'
}

export function applyAppTheme(root: Pick<HTMLElement, 'setAttribute'>, theme: AppTheme) {
  root.setAttribute('data-theme', theme)
  root.setAttribute('data-bs-theme', theme === 'midnight' ? 'dark' : 'light')
}
